import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { Floor } from '../../interfaces/state/entities/floor.interface';
import { IFloorsService } from '../../interfaces/services/floors-service.interface';

@Injectable({ providedIn: 'root' })
export class FloorsMockService implements IFloorsService {
  private floors: Floor[] = [];
  private idCounter = 0;

  constructor() {
    const now = new Date();
    const mockFloors: Floor[] = [
      {
        id: '1',
        projectId: '1',
        name: 'Ground Floor',
        currentRevision: 7,
        dateCreated: new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000),
      },
      {
        id: '2',
        projectId: '1',
        name: 'First Floor',
        currentRevision: 2,
        dateCreated: new Date(now.getTime() - 25 * 24 * 60 * 60 * 1000),
      },
      {
        id: '3',
        projectId: '1',
        name: 'Second Floor',
        currentRevision: 0,
        dateCreated: new Date(now.getTime() - 20 * 24 * 60 * 60 * 1000),
      },
      {
        id: '4',
        projectId: '1',
        name: 'Third Floor',
        currentRevision: 0,
        dateCreated: new Date(now.getTime() - 15 * 24 * 60 * 60 * 1000),
      },
      {
        id: '5',
        projectId: '2',
        name: 'Basement',
        currentRevision: 1,
        dateCreated: new Date(now.getTime() - 28 * 24 * 60 * 60 * 1000),
      },
      {
        id: '6',
        projectId: '2',
        name: 'Main Floor',
        currentRevision: 3,
        dateCreated: new Date(now.getTime() - 22 * 24 * 60 * 60 * 1000),
      },
      {
        id: '7',
        projectId: '2',
        name: 'Upper Floor',
        currentRevision: 0,
        dateCreated: new Date(now.getTime() - 18 * 24 * 60 * 60 * 1000),
      },
      {
        id: '8',
        projectId: '3',
        name: 'Storage Area',
        currentRevision: 3,
        dateCreated: new Date(now.getTime() - 20 * 24 * 60 * 60 * 1000),
      },
      {
        id: '9',
        projectId: '3',
        name: 'Loading Dock',
        currentRevision: 1,
        dateCreated: new Date(now.getTime() - 12 * 24 * 60 * 60 * 1000),
      },
    ];
    this.floors = mockFloors;
    this.idCounter = mockFloors.length;
  }

  getFloors(projectId: string): Observable<Floor[]> {
    const projectFloors = this.floors.filter((f) => f.projectId === projectId);
    return of([...projectFloors]).pipe(delay(100));
  }

  addFloor(projectId: string, name: string): Observable<Floor> {
    const floor: Floor = {
      id: String(++this.idCounter),
      projectId,
      name,
      currentRevision: 0,
      dateCreated: new Date(),
    };
    this.floors.push(floor);
    return of(floor).pipe(delay(100));
  }

  deleteFloor(id: string): Observable<void> {
    this.floors = this.floors.filter((f) => f.id !== id);
    return of(undefined).pipe(delay(100));
  }

  getFloorCountByProject(projectId: string): number {
    return this.floors.filter((f) => f.projectId === projectId).length;
  }

  getFloorById(floorId: string): Floor | undefined {
    return this.floors.find((f) => f.id === floorId);
  }

  syncCurrentRevision(floorId: string, revisionNumber: number): void {
    const floor = this.getFloorById(floorId);
    if (floor) {
      floor.currentRevision = Math.max(floor.currentRevision, revisionNumber);
    }
  }
}
